import React, { useEffect, useRef, useState } from "react";
import "./rangeSlider.scss";

export interface RangeSliderProps {
    label?: string;
    min: number;
    max: number;
    step?: number;
    value: number;
    originalValue: number;
    unit?: string;
    onChange: (value: number) => void;
    showCurrent?: boolean;
    showOriginal?: boolean;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
    label,
    min,
    max,
    step = 1,
    value,
    originalValue,
    unit = "",
    onChange,
    showCurrent = true,
    showOriginal = true,
}) => {
    const [sliderWidth, setSliderWidth] = useState(0);
    const sliderRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (sliderRef.current) {
            setSliderWidth(sliderRef.current.offsetWidth);
        }
    // eslint-disable-next-line
    }, [sliderRef.current]);

    const getValueClass = () => {
        if (value > originalValue) return "higher";
        if (value < originalValue) return "lower";
        return "same";
    };

    // Calculate position for original value label
    const getOriginalPosition = () => {
        if (!sliderWidth) return 0;
        const ratio = (originalValue - min) / (max - min);
        return ratio * sliderWidth;
    };

    return (
        <div className="range-slider">
            {label && <label className="range-slider__label">{label}</label>}

            <div className="range-slider__wrapper">
                <input
                    ref={sliderRef}
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={(e) => onChange(Number(e.target.value))}
                    className="range-slider__input"
                />
                {(showOriginal && value !== originalValue) && (
                    <div
                        className="range-slider__original-label"
                        style={{ left: `${getOriginalPosition()}px` }}
                    >
                        {originalValue}{unit}
                    </div>
                )}
            </div>

            <div className="range-slider__scale">
                <span>{min}{unit}</span>
                {showCurrent && (
                    <span className={`range-slider__current ${getValueClass()}`}>
                        {value}{unit}
                    </span>
                )}
                <span>{max}{unit}</span>
            </div>
        </div>
    );
};

export default RangeSlider;